// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"8fd6bba4","297":"637b06fb","478":"d66d3059","559":"da558c6b","573":"637b06fb","654":"d4d96061","841":"d5c75f27","928":"374dbb5e"}[chunkId] + ".chunk.css";
};